import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

const Review = () => {
  const reviewList = [
    {
      src: "/images/review1.webp",
      txt: `요양병원에 입원하신 부모님 집을
정리하기 위해 문의를 드렸는데
문의드린 당일에 오셔서 바로 해주셔서
덕분에 한시름 놓았답니다.`,
    },
    {
      src: "/images/review2.webp",
      txt: `대학교 자취하면서 집에 쓰레기가 엄청 쌓여
비우고 채우고에게 청소를 부탁했습니다.
정리부터 간단한 청소까지 싹 해주시고
소독이랑 방역까지 싹 해주고 가셨답니다`,
    },
    {
      src: "/images/review3.webp",
      txt: `베란다에 쌓여있던 버릴 물건들이랑
집안에 가전 가구 몇개와
안방에 있는 짐들 싹 버리려고 문의했는데
바로 오셔서 깔끔하게 싹 치워주셨어요`,
    },
    {
      src: "/images/review4.webp",
      txt: `베란다에 쌓여있던 버릴 물건들이랑
집안에 가전 가구 몇개와
안방에 있는 짐들 싹 버리려고 문의했는데
바로 오셔서 깔끔하게 싹 치워주셨어요`,
    },
    {
      src: "/images/review5.webp",
      txt: `이사가기전에 안쓰는 짐들
싹 정리를 요청드렸는데
너무 깔끔하게 잘해주셔서
정말정말 감사했습니다`,
    },
    {
      src: "/images/review6.webp",
      txt: `집안쪽에 창고방으로 사용하던 공간에
짐이 너무많아 정리요청을 했답니다.

오셔서 싹 처리해주고 가셨어요`,
    },
    {
      src: "/images/review7.webp",
      txt: `고독사현장 청소업체를 찾다가
우연찮게 문의를 드리게 되었는데
상담부터 작업까지 너무 친절하게 잘해주셔서
매우 만족스러웠습니다`,
    },
    {
      src: "/images/review8.webp",
      txt: `시골집을 처분하게 되어
정리요청을 드렸는데 서랍장 수납장 안쪽
작은 부분 할 것 없이 깔끔하게 싹
정리를 다 해주셨답니다`,
    },
    {
      src: "/images/review9.webp",
      txt: `돌아가신 부모님 집 정리를 혼자서 해보려다
도저히 안되어 문의를 드렸습니다.
따로 요청드린 사항들이 많았는데
하나하나 세심하게 잘해주시더라구요`,
    },
    {
      src: "/images/review10.webp",
      txt: `특수청소 요청드린 집주인입니다.
혈흔이나 구더기들 할 것 없이 깔끔하게 잘
청소해주셨고 소독과 방역까지 해주시어
뒤 탈 없이 잘 해결해주셨습니다.`,
    },
  ];

  const [count, setCount] = useState(5);

  useEffect(() => {
    if (window.innerWidth > 800) {
      setCount(5);
    } else {
      setCount(1);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth > 800) {
        setCount(5);
      } else {
        setCount(1);
      }
    });

    return () => {
      window.removeEventListener("resize", () => {
        if (window.innerWidth > 800) {
          setCount(5);
        } else {
          setCount(1);
        }
      });
    };
  }, []);

  useEffect(() => {});
  return (
    <div id="review" className="relative w-full h-full py-14 lg:py-28 xl:pb-36">
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <div className="relative w-full h-fit flex justify-center items-end flex-nowrap sm:flex-wrap gap-3">
          <div className="relative w-fit h-full">
            <img
              className="!relative w-auto lg:w-full h-full max-h-9 lg:max-h-11 xl:max-h-14 lg:pb-1 object-contain"
              alt="비우고 채우고 로고"
              src="/images/logo.webp"
              loading="lazy"
              width={433}
              height={82}
            />
          </div>
          <h2 className="font-medium -mb-1.5 md:-mb-1">고객후기</h2>
        </div>
        <p className="leading-tight lg:leading-normal text-lg lg:text-xl mt-5 lg:mt-3">
          비우고 채우고를 이용해주신 고객님들의 BEST 후기를 모아봤습니다.
        </p>
      </div>
      <Swiper
        spaceBetween={30}
        // centeredSlides={true}
        loop={true}
        slidesPerView={count}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className=" relative w-full h-full mx-auto grid"
      >
        {reviewList.map((v, i) => (
          <SwiperSlide
            key={i}
            className=" relative w-full h-full min-w-72 px-5 lg:px-0 "
          >
            <div className=" relative w-full h-full py-5">
              <div className="relative w-full h-10 max-w-44 mx-auto mb-2 animate-bounce ">
                <img
                  src="/images/iconStar.webp"
                  alt="별점 5점 만점"
                  loading="lazy"
                  className=" relative w-full h-fit object-contain"
                />
              </div>
              <div className="relative w-full h-[calc(100%-40px)] min-h-72 p-3 rounded-3xl bg-white border shadow-md">
                <img
                  className="relative w-full h-auto object-cover object-center"
                  src={v.src}
                  alt={`비우고 채우고 고객 후기 ${i + 1}`}
                  loading="lazy"
                />
                <div className=" relative w-full h-fit text-center pt-5">
                  <p>{v.txt}</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Review;
